import { useState, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { Layout, PrimaryButton, TextDetail } from '../components'
import { signUp } from '../reducks/users/operations'
import { push } from 'connected-react-router'
import styled from 'styled-components'
// mui
import Button from '@material-ui/core/Button'
import TextField from '@material-ui/core/TextField'

const SignUp = () => {
    const dispatch = useDispatch()

    const [isConfirm, setIsConfirm] = useState(false)
    const [lastname, setLastname] = useState('');
    const [firstname, setFirstname] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');

    const validateInputs = (lastname,firstname,email,password,confirmPassword) => {
        if (lastname === '' || firstname === '' || email === '' || password === '' || confirmPassword === '' ) {
            alert('未入力の必須項目があります')
            return false
        }
        // email validation
        const regexEmail = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/
        if (!regexEmail.test(email)) {
            alert('メールアドレスの形式が不正です。もう1度お試しください。')
            return false
        }
        // password validation
        const regexPassword = /^(?=.*?[a-z])(?=.*?[A-Z])(?=.*?\d)[a-zA-Z\d]{8,40}$/
        if (!regexPassword.test(password)) {
            alert('パスワードの形式が不正です。パスワードは半角英小文字大文字数字それぞれ1種類以上含む8文字以上40文字以下で設定できます。')
            return false
        }
        if (password !== confirmPassword) {
            alert('パスワードが一致しません')
            return false
        }
        setIsConfirm(true)
    }
    
    const inputLastname = useCallback( event => {
        setLastname(event.target.value)
    }, [setLastname]);
    const inputFirstname = useCallback( event => {
        setFirstname(event.target.value)
    }, [setFirstname]);
    const inputEmail = useCallback( event => {
        setEmail(event.target.value)
    }, [setEmail]);
    const inputPassword = useCallback( event => {
        setPassword(event.target.value)
    }, [setPassword]);
    const inputConfirmPassword = useCallback( event => {
        setConfirmPassword(event.target.value)
    }, [setConfirmPassword]);

    return (
        <Layout>
            <div className='spacer-100'></div>
            {isConfirm ? (
                <>
                <h1 style={{textAlign:'center'}}>登録内容の確認</h1>
                <div className='spacer-50'></div>
                <InputWrapper>
                    <p>以下の内容で登録します。</p>
                    <div className='spacer-25' />
                    <TextDetail label="お名前" value={`${lastname} ${firstname}`} />
                    <TextDetail label="メールアドレス" value={email} />
                    <TextDetail label="パスワード" value={'非表示'} />
                    <div className='spacer-50' />

                    <div style={{textAlign:'center'}}>
                        <PrimaryButton 
                            label="登録を完了させる"
                            operation={ () => dispatch(signUp(lastname,firstname,email,password,confirmPassword)) } 
                            />
                        <div className='spacer-25' />
                        <Button onClick={()=>setIsConfirm(false)}>キャンセル</Button>
                    </div>
                </InputWrapper>
                </>
            ):(
                <>
                <h1  style={{textAlign:'center'}}>新規会員登録</h1>
                <div className='spacer-50'></div>
                <InputWrapper>
                    <TextField 
                        fullWidth={false} label={'姓'} multiline={false} required={true} variant="filled"
                        rows={1} value={lastname} type={'text'} onChange={inputLastname}
                        style={{width: '150px', marginRight: '20px', marginBottom: '10px'}}
                    />
                    <TextField 
                        fullWidth={false} label={'名'} multiline={false} required={true} variant="filled"
                        rows={1} value={firstname} type={'text'} onChange={inputFirstname}
                        style={{width: '150px'}}
                    />
                    <TextField 
                        fullWidth={true} label={'メールアドレス'} multiline={false} required={true} variant="filled"
                        rows={1} value={email} type={'email'} onChange={inputEmail}
                        style={{marginBottom: '10px'}}
                    />
                    <TextField 
                        fullWidth={true} label={'パスワード'} multiline={false} required={true} variant="filled"
                        rows={1} value={password} type={'password'} onChange={inputPassword}
                        style={{marginBottom: '10px'}}
                    />
                    <TextField 
                        fullWidth={true} label={'パスワード（確認用）'} multiline={false} required={true} variant="filled"
                        rows={1} value={confirmPassword} type={'password'} onChange={inputConfirmPassword}
                    />
                </InputWrapper>
                <div className='spacer-50'></div>
                <div style={{textAlign:'center'}}>
                    <PrimaryButton 
                        label={"新規会員登録をする"} 
                        operation={ ()=> validateInputs(lastname,firstname,email,password,confirmPassword) } 
                    />
                    <div className='spacer-50' />
                    <p onClick={()=>dispatch(push('/signin'))}>アカウントをお持ちの方はこちら</p>
                </div>
                </>
            )}
            <div className='spacer-100'></div>
        </Layout>
    )
}
export default SignUp

const InputWrapper = styled.div`
    width: 320px;
    margin: 0 auto;
`